module.exports = __webpack_public_path__ + "img/IEC30423.c45a84d9.png";